@if (servicesPage) {
  <div id="projects" class="card mt-2">
    <div class="card-header">
      <div class="card-header-title">
        Jobs
      </div>
      @if (isOnExportUsed) {
        <button  (click)="exportData()" class="btn btn-white btn-sm float-right">
          Export Data
          <span class="svg-icon svg-icon-xs ms-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>ionicons-v5-a</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
          </span>
        </button>
      }
    </div>
    <div class="table-responsive">
      <table class='table table-sm card-table table-wrap"' aria-labelledby="tableLabel">
        <thead>
          <tr>
            <th class="vehicle">Vehicle</th>
            <th class="location">Location Name</th>
            <th class="arrived">Arr</th>
            <th class="departed">Dep</th>
            <th class="time text-center">Time at Site</th>
            @if (showVariance()) {
              <th class="variance text-center">VA</th>
            }
            <th class="in text-center">Cont In</th>
            <th class="out text-center">Cont Out</th>
          </tr>
        </thead>
        <tbody>
          @for (service of servicesPage; track service) {
            <tr [className]="service.alert && dashboardMode != DashboardMode.Irregular ? 'warning' : ''" (click)="goToLocation(service.locationId)">
              <td class="vehicle"><div class="trunc">{{ service.vehicleName }}</div></td>
              <td class="location"><div class="trunc">{{ service.locationName }}</div></td>
              <td class="arrived" title="{{ service.arrivedAt | date:'mediumDate' }}"><div class="trunc">{{ service.arrivedAtFormatted }}</div></td>
              <td class="departed"title="{{ service.departedAt | date:'mediumDate' }}"><div class="trunc">{{ service.departedAtFormatted }}</div></td>
              <td class="time text-center"><div class="trunc">{{ service.timeAtSiteFormatted }}</div></td>
              @if (showVariance()) {
                <td class="variance text-center"><div [className]="service.variance == 0 ? 'trunc' : service.variance > 0 ? 'warning trunc' : 'good trunc'">{{ service.variance }}</div></td>
              }
              <td class="in text-center"><div class="trunc">{{ service.containerIn }}</div></td>
              <td class="out text-center"><div class="trunc">{{ service.containerOut }}</div></td>
            </tr>
          }
        </tbody>
        <tbody class="list">
          <tr>
            <td class="h-2" colspan="8"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}